export default "__VITE_ASSET__evqXxgKRQgSDrlJtdwrREQ__"